import { ScrollReveal } from "./ScrollReveal";

const offers = [
  { title: "Stand-up", description: "Profesjonalny występ stand-upowy dopasowany do charakteru Twojej firmy. Gwarantujemy świetną zabawę i pozytywne emocje.", features: ["Występ 45-60 minut", "Materiał dostosowany do odbiorców", "Interakcja z publicznością"], emoji: "🎤" },
  { title: "Eventy firmowe", description: "Kompleksowa obsługa eventów firmowych z elementami komediowymi. Idealne na integracje i wydarzenia specjalne.", features: ["Prowadzenie eventu", "Skecze i scenki", "Konkursy z humorem"], emoji: "🎪" },
  { title: "Szkolenia", description: "Szkolenia z elementami humoru, które uczą i bawią jednocześnie. Efektywna nauka przez śmiech.", features: ["Warsztaty team building", "Ćwiczenia integracyjne", "Praktyczne zadania"], emoji: "🎓" },
  { title: "Imprezy prywatne", description: "Profesjonalna oprawa komediowa imprez prywatnych. Idealne na urodziny, wesela i inne okazje.", features: ["Występy dedykowane", "Roasty okolicznościowe", "Prowadzenie imprez"], emoji: "🎉" },
  { title: "Gale i konferencje", description: "Profesjonalne prowadzenie gal i konferencji z elementami humoru. Elegancja połączona z rozrywką.", features: ["Prowadzenie ceremonii", "Przerywniki komediowe", "Dostosowany format"], emoji: "🏆" },
  { title: "Comedy Show", description: "Kompleksowy program rozrywkowy łączący różne formy komedii. Pełen wieczór śmiechu i zabawy.", features: ["Mix form komediowych", "2-3 godziny programu", "Różni wykonawcy"], emoji: "🎭" },
];

export const Offer = () => {
  return (
    <section id="offer" className="py-24 bg-background">
      <div className="container">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="text-accent font-semibold text-sm uppercase tracking-widest">Nasza oferta</span>
            <h2 className="text-4xl md:text-5xl font-montserrat font-black mt-3 text-foreground">
              Co możemy dla Ciebie zrobić
            </h2>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {offers.map((offer, i) => (
            <ScrollReveal key={offer.title} delay={i * 100}>
              <div className="group h-full p-8 rounded-2xl bg-secondary/30 border border-border/50 card-hover hover:border-accent/30 hover:bg-secondary/60">
                <span className="text-4xl mb-4 block">{offer.emoji}</span>
                <h3 className="text-2xl font-montserrat font-bold mb-3 text-foreground group-hover:text-accent transition-colors">{offer.title}</h3>
                <p className="text-muted-foreground mb-4 text-sm leading-relaxed">{offer.description}</p>
                <ul className="space-y-2">
                  {offer.features.map((f) => (
                    <li key={f} className="flex items-center gap-2 text-sm text-muted-foreground">
                      <span className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" />
                      {f}
                    </li>
                  ))}
                </ul>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};
